import { render, staticRenderFns } from "./NavigationCollapseBar.vue?vue&type=template&id=5ed35e62&"
import script from "./NavigationCollapseBar.vue?vue&type=script&lang=js&"
export * from "./NavigationCollapseBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports